import DataTable from 'react-data-table-component';
import List from '@material-ui/core/List';
import styled, { css } from "styled-components";

import Button from "../../components/Button";
import FieldBoxOrg from "../../components/FieldBox";

interface AggregationItemProps {
    color: string;
}

interface RegisterDataProps {
    color?: string;
}

export const ButtonNewItem = styled(Button)`
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    max-width: 200px !important;
    width: auto !important;
    background: rgba(251,50,92,1);
    background: linear-gradient(90deg,rgba(255,140,47,1) 25%,rgba(251,50,92,1) 50%,rgba(147,55,237,1) 75%);

    :hover {
        background: linear-gradient(90deg, rgba(255,140,47,0.75) 25%, rgba(251,50,92,0.75) 50%, rgba(147,55,237,0.75)75%);
    }

    div {
        margin-top: 3px !important;

        svg {
            width: 18px;
            height: 18px;
        }
    }

    @media(max-width: 800px){
        display: none !important;
    }
`;

export const FieldContainer = styled.div`
    margin-bottom: 15px;
`;

export const FieldBox = styled(FieldBoxOrg)`
    min-height: 30px !important;
    height: 80px !important;
    margin-bottom: 15px;
`;

export const ButtonConfig = styled(Button)`
    width: 50px !important;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
        margin-right: 0px !important; 
        margin-top: 3px;
    }

    @media(max-width: 800px){
        display: none;
    }
`;

export const RightPanelItems = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 20px;
`;

export const ButtonUserAdd = styled(Button)`
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    height: 35px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #4681b8;
    background-color: white;
    border: 1px dashed #4681b8;
    overflow: hidden;
    width: 120px !important;

    div {
        margin-top: 2px !important;

        svg {
            width: 18px;
            height: 18px;
            color: #4681b8;
        }
    }

    :hover {

        border: 1px dashed #f23b5c;
        background-color: white;
        color: #f23b5c;

        svg {
            color: #f23b5c;
        }

    }

    @media(max-width: 800px){
        display: none !important;
    }
`;

export const ButtonNewItemMobile = styled.button`

    display: none;

    @media(max-width: 800px){
        display: flex;
        position: absolute;
        //bottom: 15px;
        bottom: 100px;
        right: 5px;
        background: linear-gradient(145deg,rgb(255 140 47) 25%,rgb(251 50 92) 50%,rgb(147 55 237) 75%);
        font-size: 25px;
        margin-right: 0px;
        height: 60px !important;
        width: 60px !important;
        border-radius: 50%;
        z-index: 99998;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
    }

`;

export const RightPanelList = styled(List)`
    width: 100%;
`;


export const ContainerBody = styled.div`
    display: flex;
    height: calc(100% - 100px);
    align-items: baseline;
    justify-content: left;
    margin-top: 10px;
    width: 100%;
`;

export const ContainerContent = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 10px;
`;

export const NoRegister = styled.span`
    color: gray;
    font-style: italic;
`;

export const RegisterData = styled.span<RegisterDataProps>`
    line-height: 1;
    margin: 0px 2px;
    padding: 3px 5px;
    white-space: nowrap;
    border-radius: 5px;
    font-size: 13px;
    padding: 5px 10px;
    margin-right: 5px;
    color: rgba(51,51,51,0.9);
    background-color: #4681b81e;

    ${(props) => props.color && css`
      background-color: ${props.color + "1e"};
    `}
`

export const AutomaticData = styled.span`
    line-height: 1;
    margin: 0px 2px;
    padding: 3px 5px;
    white-space: nowrap;
    border-radius: 3px;
    font-size: 13px;
    border: 1px solid rgb(238, 238, 238);
    color: rgba(51, 51, 51, 0.9);
    background-color: rgb(248, 248, 248);
`;

export const DataTableCange = styled(DataTable)`

    border-radius: 10px;

    .rdt_TableHeadRow {
        min-height: 50px;
        border-bottom: 1px solid #f4f5f7;
        border-top: 1px solid #f4f5f7;
    }

    .rdt_TableCol_Sortable {
        border: none;

        div {
            background-color: #f4f5f7;
            padding: 5px 10px;
            border-radius: 5px;
            font-weight: 500;
        }
    }

    .rdt_TableCell {
        //min-width: 175px;
        overflow: hidden; 
        border-right: 1px solid #f4f5f7;
        border-left: none;
    }

    .rdt_TableCol {
        display: flex;
        justify-content: center;
        align-items: center;

        border-right: 1px solid #f4f5f7;
        border-left: none;
    }

    .rdt_TableCol_Sortable {
        display: flex;
        justify-content: center;
        width: 100%;
        //margin-left: 18px;
        //overflow: hidden;
        align-items: center;
        text-align: center;
    }

    .rdt_TableRow {
        min-height: 45px;
        border: none;
    }

`;

export const AggregationContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-content: center;
    margin-bottom: 10px;
`;

export const AggregationItem = styled.div<AggregationItemProps>`
    display: flex;
    justify-content: flex-start;
    align-content: center;
    min-width: 215px;
    background-color: white;
    border-radius: 10px;
    padding: 10px;
    padding-left: 15px;
    padding-right: 15px;
    margin-right: 15px;

    background-color: #9d37ed1e;
    border-left: 10px solid #9d37ed;
    ${(props) => props.color && css`
      background-color: ${props.color + "1e"};
      border-left: 10px solid ${props.color};
    `}

    :hover {
        .aggregateConfig {
            display: flex;
        }
    }

`;

export const AggregateItemLeft = styled.div`
    width: 100%;
    margin-right: 10px;
`;

export const AggregationName = styled.div`
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 500;
    color: gray;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const AggregationNameText = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 15ch;
`;

export const AggregationValue = styled.div`
    font-size: 25px;
    font-weight: 500;
    color: #4d4d4d;
    margin-top: 5px;
    overflow: hidden;
`;

export const AggregateItemRight = styled.div`
    font-size: 15px;
    color: gray;
    min-width: 15px;
`;

export const AggregateConfig = styled.div`
    display: none;
`;

export const AggregationNameType = styled.span`
    font-size: 11px;
    color: gray;
    margin-left: 5px;
    text-transform: lowercase;
    font-style: italic;
`;

export const DropDownInfo = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #101820;
    font-weight: 400;
    font-size: 13px;
    margin-top: 5px;
    border-radius: 10px;
    padding: 10px;

    span { 
        margin-right: 5px;
        color: grey;
    }
`;

export const LoaderContainer = styled.div`
    margin-bottom: 15px;
    margin-top: 10px;

    svg {
        max-width: 100%;
    }
`;

export const ContainerDynamicTextView = styled.div`

    font-family: Helvetica, Arial, sans-serif;
    font-size: 13px;

    strong {
        font-weight: 600;
    }

    ol, ul {
        padding-left: 2.5em;
    }

`;